<template>
  <v-container fluid grid-list-lg transition="slide-x-transition">
    <v-card>
      <v-card-title>
        <div class="title">{{ pagename }}</div>
        
        <v-spacer></v-spacer>

        <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar..."
            single-line
            hide-details
        ></v-text-field>

            
        <v-dialog v-model="dialogPsw" max-width="500px">
          <v-card>
            <v-form
            ref="formUserPsw"
            class="pa-4"
            v-model="validFormPsw"
            lazy-validation
            >
            <!-- v-on:submit.prevent="submitUser" -->
              <v-card-title>
                <span class="headline">Cambio de Contraseña</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field 
                      type="password" 
                      v-model="editedItem.newpassword" 
                      :error-messages="passwordMatchError"
                      :rules="newpasswordRules" 
                      label="Contraseña">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field 
                      type="password" 
                      v-model="editedItem.repassword" 
                      :error-messages="passwordMatchError"
                      :rules="repasswordRules" 
                      label="Repetir Contraseña">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="closePsw">Cancelar</v-btn>
                <v-btn color="blue darken-1" flat @click="savePsw" :disabled="!validFormPsw">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog">
          <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo usuario</v-btn>
          <v-card>
            <v-form
            ref="formUser"
            class="pa-4"
            v-model="validForm"
            lazy-validation
            >
            <!-- v-on:submit.prevent="submitUser" -->
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field :rules="requireRules" v-model="editedItem.nombres" label="Nombres"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field :rules="requireRules" v-model="editedItem.apellidos" label="Apellidos"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field type="email" :rules="emailRules" v-model="editedItem.correo_login" label="Correo"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field :rules="requireRules" v-model="editedItem.login" label="Usuario"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                      :rules="rolRules"
                      v-model="editedItem.perfil"
                      :items="perfiles"
                      item-text="nombre_perfil"
                      item-value="id_perfil"
                      label="Perfil"
                      return-object
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                      :rules="requireRules"
                      v-model="editedItem.estado"
                      :items="estados"
                      item-text="nombre_estado"
                      item-value="valor_estado"
                      label="Estado"
                      return-object
                      ></v-select>
                    </v-flex>
                    <v-flex v-if="editedIndex == -1" xs12 sm6 md6>
                      <v-text-field 
                      type="password" 
                      v-model="editedItem.newpassword" 
                      :error-messages="passwordMatchError"
                      :rules="newpasswordRules" 
                      label="Contraseña">
                      </v-text-field>
                    </v-flex>
                    <v-flex v-if="editedIndex == -1" xs12 sm6 md6>
                      <v-text-field 
                      type="password" 
                      v-model="editedItem.repassword" 
                      :error-messages="passwordMatchError"
                      :rules="repasswordRules" 
                      label="Repetir Contraseña">
                      </v-text-field>
                    </v-flex>
                    <template v-if="editedItem.perfil && editedItem.perfil.id_perfil == 3">
                    <v-flex xs12 sm6 md6>
                      <v-btn
                        color="accent"
                        dark
                        small
                        class="mx-2"
                        @click="attachSignature"
                        title="Cargar Firma"
                      >
                        <v-icon dark>cloud_upload</v-icon>
                        firma (300x195 pixeles)
                      </v-btn>
                      <input
                        type="file"
                        style="display: none"
                        ref="attachmentSignature"
                        accept="image/*"
                        @change="onAttachSignature" >                        
                    </v-flex>
                    <v-flex xs12 sm6 md6 elevation-1>
                      <small v-if="signature">{{ (editedItem.firma ? 'Reemplazando: ' : 'Cargando: ') + signature.name }}</small>
                        <v-img
                          v-else-if="editedItem.firma"
                          :src="editedItem.firma"
                          max-height="200"
                          contain
                        ></v-img>
                        <small v-else>No hay una firma cargada.</small>
                    </v-flex>
                    </template>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn depressed @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="save" :disabled="!validForm">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        

      </v-card-title>

      <v-data-table
      :headers="headers"
      :items="usuarios"
      :pagination.sync="pagination" 
      class="elevation-1"
      :search="search"
      >
        <template slot="items" slot-scope="props">
          <tr :data-item="JSON.stringify(props.item)" :data-rol="JSON.stringify(props.item.rol)">
            <td>{{ props.item.nombres }}</td>
            <td class="text-xs-left">{{ props.item.apellidos }}</td>
            <td class="text-xs-left">{{ props.item.login }}</td>
            <td class="text-xs-left">{{ props.item.correo_login }}</td>
            <td class="text-xs-left">{{ props.item.perfil.nombre_perfil }}</td>
            <td class="text-xs-left">{{ props.item.alive }}</td>
            <td class="text-xs-left">{{ props.item.estado.nombre_estado }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                  small
                  class="mr-2"
                  @click="editItem(props.item)"
              >
                  edit
              </v-icon>
              <v-icon
                  small
                  class="mr-2"
                  @click="changepswItem(props.item)"
              >
                  vpn_key
              </v-icon>
              <v-icon
                  small
                  @click="deleteItem(props.item)"
              >
                  delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
          Su busqueda para "{{ search }}" no obtuvo resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  // import { bus } from './../main';
  import axios from 'axios';
  var moment = require('moment');
  const confBase = {
    timeout: 10000,
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'x-www-form-urlencoded',
    },
    params: {}
  }
  export default {
    mounted() {
      // console.log('$route.params', this.$route.params.carrera_id)      
      this.logged_user = JSON.parse(localStorage.getItem("logged_user"))

      if (this.logged_user && this.logged_user.id_perfil == 4) {
        this.$router.push({ name: 'Find' })
      }
      
      this.initialize()
    },
    data: () => ({
      pagename: 'USUARIOS',
      logged_user: null,
      loading: false,
      perfiles: [],
      dialog: false,
      dialogPsw: false,
      snack: false,
      snackColor: '',
      snackText: '',
      headers: [
        {
          text: 'Nombres',
          align: 'left',
          value: 'nombres'
        },
        {
          text: 'Apellidos',
          align: 'left',
          value: 'apellidos'
        },
        { text: 'Usuario', align: 'left', value: 'login' },
        { text: 'Correo', align: 'left', value: 'correo_login' },
        { text: 'Perfil', align: 'left', value: 'perfil.nombre_perfil' },
        { text: 'Creado', value: 'fecha_registro' },
        { text: 'Acciones', sortable: false }
      ],
      pagination: {
        sortBy: 'fecha_registro',
        descending: true,
        rowsPerPage: 10
      },
      search: '',
      usuarios: [],
      editedIndex: -1,
      editedItem: {
          id: null,
          nombres: '',
          apellidos: '',
          login: '',
          correo_login: '',
          fecha_creacion: moment({}).format('YYYY-MM-DD H:mm:ss'),
          id_rol: 0,
          perfil: null,
          estado: null,
          firma: null,
          newpassword: '',
          repassword: ''
      },
      defaultItem: {
          id: null,
          nombres: '',
          apellidos: '',
          login: '',
          correo_login: '',
          fecha_creacion: moment({}).format('YYYY-MM-DD H:mm:ss'),
          id_rol: 0,
          perfil: null,
          estado: null,
          firma: null,
          newpassword: '',
          repassword: ''
      },
      validForm: false,
      validFormPsw: false,
      requireRules: [v => !!v || "Campo es requerido"],
      emailRules: [
        v => !!v || "Correo es requerido",
        v => /.+@.+/.test(v) || "El correo debe ser válido"
      ],
      rolRules: [
        v => !!v || "Debe asignar un rol"
      ],
      newpasswordRules: [
        v => !!v || "Password es requerido",
        v => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
        // v => v === this.editedItem.repassword || "Ambos password deben ser iguales"
      ],
      repasswordRules: [
        v => !!v || "Password es requerido",
        v => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
        // v => v === this.editedItem.newpassword || "Ambos password deben ser iguales"
      ],
      estados: [
        {'nombre_estado': 'Inactivo', 'valor_estado': 0},
        {'nombre_estado': 'Activo', 'valor_estado': 1}
      ],
      signature: null
    }),

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
        },
        passwordMatchError () {
            return ( this.editedItem.newpassword === this.editedItem.repassword ) ? '' : 'Ambos password deben ser iguales'
        }
    },

    watch: {
        dialog (val) {
            val || this.close()
        }
    },

    methods: {
      initialize () {
        this.loading = true
        Promise.all(
          [this.getUsuarios(), this.getPerfiles()]
        ).then(response => {
          this.snackColor = 'success'
          this.snackText = response.join(' y ')
          this.snack = true
        }).catch(reason => {
          this.snackColor = 'error'
          this.snackText = reason
          this.snack = true
          //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        }).finally(() => {
          this.loading = false
        })
      },

      getUsuarios () {
        return new Promise((resolve, reject) => {
          confBase.params = {
            accion: 'usuarios',
            opcion: 'listarUsuarios',
            api_token: this.logged_user.api_token
          }
          axios
            .create(confBase)
            .get(window.base_path + window.ws)
            .then(result => {
              if (result.data.response) {
                console.log(JSON.parse(JSON.stringify(result.data.callback)))
                this.usuarios = result.data.callback.map(usuario => {
                  usuario.estado = this.estados.find(el => el.valor_estado == usuario.estado)
                  usuario.alive = moment(usuario.fecha_registro).locale('es').fromNow()
                  return usuario
                })

                resolve('Usuarios cargados')
              }else {
                reject('No data result')
              }
            })
        })
      },

      getPerfiles () {
        return new Promise((resolve, reject) => {
          confBase.params = {
            accion: 'perfiles',
            opcion: 'listarPerfiles',
            api_token: this.logged_user.api_token
          }
          axios
            .create(confBase)
            .get(window.base_path + window.ws)
            .then(result => {
              if (result.data.response) {
                console.log(JSON.parse(JSON.stringify(result.data.callback)))
                this.perfiles = result.data.callback
                resolve('Perfiles cargados')
              }else {
                reject('No data result')
              }
            })
        })
      },

      editItem (item) {
          this.editedIndex = this.usuarios.indexOf(item)
          // item.fecha_creacion = moment({}).format()
          this.editedItem = Object.assign({}, item)
          this.dialog = true
          console.log('editando', JSON.parse(JSON.stringify(this.editedItem)))
      },            
      
      deleteItem (item) {
          const index = this.usuarios.indexOf(item)
          const logged_user = JSON.parse(localStorage.getItem("logged_user"))
          //confirm('¿Está seguro que desea eliminar este usuario?') //&& this.usuarios.splice(index, 1)
          if (confirm('¿Está seguro que desea eliminar este usuario: '+item.login+'?')) {
              axios({
                  'method': 'post',
                  'withCredentials': true,
                  'url': window.base_path + window.ws, 
                  'data': {
                      api_token: logged_user.api_token,
                      accion: 'usuarios',
                      opcion: 'borrarUsuario',
                      id_usuario: item.id_usuario
                  }
              })
              .then(result => { 
                  // console.log(result)
                  if (result.data.response) { 
                      this.snackColor = 'success'
                      this.snackText = result.data.mensaje
                      this.usuarios.splice(index, 1)
                  } else { 
                      this.snackColor = 'error'
                      this.snackText = result.data.mensaje
                  }
                  this.snack = true
              })
              .catch(error => {
                  // console.log('error',error)
                  this.snackColor = 'error'
                  this.snackText = error.response
                  this.snack = true
                  //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
              });
          }
      },

      close () {
          this.dialog = false
          setTimeout(() => {
              this.editedItem = Object.assign({}, this.defaultItem)
              this.signature = null
              this.editedIndex = -1
          }, 300)
      },

      save () {
          /*
              id_usuario
              id_perfil
              login
              correo_login
              nombres
              apellidos
              password
          */
          var newrow = Object.assign({}, this.editedItem)
          var contentData = {
              api_token: this.logged_user.api_token,
              accion: 'usuarios',
              opcion: this.editedIndex > -1 ? 'editarUsuario' : 'nuevoUsuario',
              id_usuario: this.editedIndex > -1 ? this.editedItem.id_usuario : null,
              id_perfil: this.editedItem.perfil.id_perfil,
              login: this.editedItem.login,
              correo: this.editedItem.correo_login,
              nombres: this.editedItem.nombres,
              apellidos: this.editedItem.apellidos,
              password: this.editedIndex > -1 ? null : this.editedItem.newpassword,
              estado: this.editedItem.estado.valor_estado
          }

          let formData = new FormData()
          formData.append('api_token', this.logged_user.api_token)
          formData.append('accion', 'usuarios')
          formData.append('opcion', this.editedIndex > -1 ? 'editarUsuario' : 'nuevoUsuario')
          formData.append('id_usuario', this.editedIndex > -1 ? this.editedItem.id_usuario : null)
          formData.append('id_perfil', this.editedItem.perfil.id_perfil)
          formData.append('login', this.editedItem.login)
          formData.append('correo', this.editedItem.correo_login)
          formData.append('nombres', this.editedItem.nombres)
          formData.append('apellidos', this.editedItem.apellidos)
          formData.append('password', this.editedIndex > -1 ? null : this.editedItem.newpassword)
          formData.append('estado', this.editedItem.estado.valor_estado)
          if (this.signature) {
            formData.append('firma', this.signature)            
          }

          console.log('contentData', formData)

          if (this.$refs.formUser.validate()) {
              console.log('formulario válido')
              axios({
                'method': 'post',
                'withCredentials': true,
                'headers': {
                  'Content-Type': 'multipart/form-data'
                },
                'url': window.base_path + window.ws, 
                'data': formData
              })
              .then(result => { 
                  // console.log(result)
                  if (result.data.response) { 
                      console.log('response true', this.editedIndex)
                      this.snackColor = 'success'
                      this.snackText = result.data.mensaje
                      let filename = this.editedItem.login + '.' + this.signature.name.split('.').pop()
                      if (this.editedIndex > -1) {
                          //console.log('edit',JSON.parse(JSON.stringify(this.editedItem)))
                          this.editedItem.firma = window.base_path + '/firmas/' + filename
                          Object.assign(this.usuarios[this.editedIndex], this.editedItem)
                      } else {
                          console.log('insert', result.data.callback, JSON.parse(JSON.stringify(this.editedItem)))
                          /*
                            apellidos: "Godoy Soto"
                            api_token: ""
                            correo_login: "pgodoy@nubedesign.cl"
                            estado: "1"
                            fecha_modificacion: "2019-05-22 04:07:26"
                            fecha_registro: "2019-04-11 00:00:00"
                            id_usuario: "1"
                            login: "pgodoy"
                            nombres: "Pedro Eduardo"
                            perfil: {id_perfil: "1", nombre_perfil: "Administrador"}
                          */
                          newrow.id_usuario = result.data.usuario_id
                          newrow.fecha_registro = result.data.fecha_creacion
                          newrow.alive = moment(result.data.fecha_creacion).locale('es').fromNow()
                          newrow.firma = window.base_path + '/firmas/' + filename

                          this.usuarios.push(newrow)
                          //console.log('new row', JSON.parse(JSON.stringify(newrow)))
                      }
                      //setTimeout(() => {
                          this.$refs.formUser.reset()
                          this.signature = null
                          this.close()
                      //}, 1000)
                  } else { 
                      console.log('response false')
                      this.snackColor = 'error'
                      this.snackText = result.data.mensaje
                  }
                  this.snack = true
              })
              .catch(error => {
                  // console.log('error',error)
                  this.snackColor = 'error'
                  this.snackText = error.response
                  this.snack = true
                  //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
              });
          } else {
              console.log('formulario inválido')
          }
          
          //return

          /* const editUsuarios = axios.create({
              timeout: 10000,
              withCredentials: true,
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'x-www-form-urlencoded',
              },
              params: contentData
          }); */
          
          /*
              editUsuarios.post(window.base_path + window.ws)
              .then(result => {
                  console.log(JSON.parse(JSON.stringify(result)))
                  
                  if (result.data.response) {

                  } else {
                      // bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
                  }
                  
              }).catch(error => {
                  // console.log('error',error)
                  // bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
              })
          */
          
      },
      
      changepswItem (item) {
          this.editedIndex = this.usuarios.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.dialogPsw = true                
          console.log('changepswItem')
          console.log(JSON.parse(JSON.stringify(this.editedItem)))
      },
      
      closePsw () {
          this.dialogPsw = false
          setTimeout(() => {
              this.editedItem = Object.assign({}, this.defaultItem)
              this.editedIndex = -1
          }, 300)
      },
      
      savePsw () {
          const logged_user = JSON.parse(localStorage.getItem("logged_user"))
          console.log('savePsw')

          if (this.$refs.formUserPsw.validate()) {
              console.log('formulario válido')
              console.log(JSON.parse(JSON.stringify(this.editedItem)))

              var contentData = {
                  api_token: logged_user.api_token,
                  accion: 'usuarios',
                  opcion: 'cambiarContrasena',
                  id_usuario: this.editedItem.id_usuario,
                  password: this.editedItem.newpassword
              }
              
              axios({
                  'method': 'post',
                  'withCredentials': true,
                  'url': window.base_path + window.ws, 
                  'data': contentData
              })
              .then(result => { 
                  // console.log(result)
                  if (result.data.response) { 
                      // console.log('response true', this.editedIndex)
                      this.snackColor = 'success'
                      this.snackText = result.data.mensaje
                      //setTimeout(() => {
                          this.$refs.formUserPsw.reset()
                          this.closePsw()
                      //}, 1000)
                  } else { 
                      console.log('response false')
                      this.snackColor = 'error'
                      this.snackText = result.data.mensaje
                  }
                  this.snack = true
              })
              .catch(error => {
                  // console.log('error',error)
                  this.snackColor = 'error'
                  this.snackText = error.response
                  this.snack = true
                  //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
              });
          } else {
              console.log('formulario inválido')
          }
      },

      attachSignature () {
        this.$refs.attachmentSignature.click()
      },

      onAttachSignature (attachs) { 
        if (this.$refs.attachmentSignature.files.length > 0) {
          this.signature = this.$refs.attachmentSignature.files[0];
        }
        
        console.log('onAttachSelectFirma', attachs, this.signature)
      },
    }
  }
</script>